export default __webpack_public_path__ + "static/media/9.1b63b17e.jpg";